'use strict';
var BASWebServices;
(function (BASWebServices) {
    var AjaxQueue = (function () {
        function AjaxQueue(maximumParallelJobs, $http, ngProgressbar, callbackFinished) {
            this.maximumParallelJobs = maximumParallelJobs;
            this.$http = $http;
            this.ngProgressbar = ngProgressbar;
            this.callbackFinished = callbackFinished;
            this.chainIsDone = false;
            this.maxCount = 0;
            this.alreadyProcessed = 0;
            this.ajaxQueue = new Array();
            this.jobsCurrentlyBeingProcessed = 0;
            this.ngProgressbarStarted = false;
            this.minProgressBarLength = 10;
            this.sizeProcessed = 0;
            this.totalSize = 0;
            this.startTime = new Date();
        }
        AjaxQueue.prototype.ajaxEnqueue = function (methodStr, urlStr, numberOfQueryInt, callerObjectCtx, success, failure) {
            var _this = this;
            this.maxCount = this.maxCount + 1;
            var params = {
                method: methodStr,
                url: urlStr,
                callerObjectContext: callerObjectCtx,
                numberOfQuery: numberOfQueryInt,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
            };
            this.ajaxQueue.push(function () {
                _this.$http(params).then(function (response) {
                    var data = response.data;
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    success(data, status, headers, config);
                    _this.alreadyProcessed++;
                    _this.jobsCurrentlyBeingProcessed--;
                    _this.ajaxDequeue();
                }).catch(function (response) {
                    var data = response.data;
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    failure(data, status, headers, config);
                    _this.alreadyProcessed++;
                    _this.jobsCurrentlyBeingProcessed--;
                    _this.ajaxDequeue();
                });
            });
            var dequeueCall = function () { _this.ajaxDequeue(); };
            dequeueCall();
        };
        AjaxQueue.prototype.ajaxEnqueueFormData = function (formData, urlStr, callerObjectCtx, runningNumber, size, success, failure) {
            var _this = this;
            this.maxCount = this.maxCount + 1;
            this.totalSize = this.totalSize + size;
            this.ajaxQueue.push(function () {
                var bytesUploadedForThisJob = 0;
                _this.$http.post(urlStr, formData, {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined },
                    uploadEventHandlers: {
                        'progress': function (event) {
                            var bytesNewlyUploaded = event.loaded - bytesUploadedForThisJob;
                            bytesUploadedForThisJob = event.loaded;
                            _this.sizeProcessed = _this.sizeProcessed + bytesNewlyUploaded;
                            _this.updateProgressbar();
                        }
                    },
                    _this: callerObjectCtx,
                    runningNumber: runningNumber
                })
                    .then(function (response) {
                    var data = response.data;
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    success(data, status, headers, config);
                    _this.alreadyProcessed++;
                    _this.jobsCurrentlyBeingProcessed--;
                    _this.sizeProcessed = _this.sizeProcessed - bytesUploadedForThisJob + size;
                    _this.ajaxDequeue();
                }).catch(function (response) {
                    var data = response.data;
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    failure(data, status, headers, config);
                    _this.alreadyProcessed++;
                    _this.jobsCurrentlyBeingProcessed--;
                    _this.sizeProcessed = _this.sizeProcessed - bytesUploadedForThisJob + size;
                    _this.ajaxDequeue();
                });
            });
            var dequeueCall = function () { _this.ajaxDequeue(); };
            dequeueCall();
        };
        AjaxQueue.prototype.ajaxDequeue = function () {
            console.log("ajaxDequeue()", {
                jobsCurrentlyBeingProcessed: this.jobsCurrentlyBeingProcessed,
                maximumParallelJobs: this.maximumParallelJobs,
                ajaxQueueLength: this.ajaxQueue.length,
                alreadyProcessed: this.alreadyProcessed,
                maxCount: this.maxCount,
            });
            this.updateProgressbar();
            if (this.ajaxQueue.length > 0) {
                if (this.jobsCurrentlyBeingProcessed < this.maximumParallelJobs) {
                    this.jobsCurrentlyBeingProcessed++;
                    var nextJob = this.ajaxQueue.shift();
                    nextJob();
                    console.log("Started a new job. Jobs currently being processed: " + this.jobsCurrentlyBeingProcessed);
                }
            }
            else {
                if (this.jobsCurrentlyBeingProcessed == 0) {
                    this.removeProgressbarText();
                    this.ngProgressbar.complete();
                    this.ngProgressbarStarted = false;
                    this.callbackFinished();
                }
            }
        };
        AjaxQueue.prototype.updateProgressbar = function () {
            var percentage = this.alreadyProcessed / this.maxCount * 100;
            var percentageSize = this.sizeProcessed / this.totalSize * 100;
            if (this.totalSize) {
                this.ngProgressbar.set(percentageSize);
            }
            else {
                this.ngProgressbar.set(percentage);
            }
            var progressbarElement = this.ngProgressbar.getDomElement()[0];
            var textContainer = progressbarElement.querySelector(".progress-bar-text");
            if (!textContainer) {
                textContainer = document.createElement("div");
                textContainer.classList.add("progress-bar-text");
                progressbarElement.appendChild(textContainer);
            }
            if (percentageSize) {
                textContainer.innerHTML =
                    this.formatSize(this.sizeProcessed) + "/" + this.formatSize(this.totalSize) + " uploaded " +
                        "(" + Math.round(percentageSize) + " %)" +
                        "<br>Started at " + this.formatTime(this.startTime);
                var currentTime = new Date();
                var elapsedTime = currentTime.valueOf() - this.startTime.valueOf();
                var durationEstimate = elapsedTime / percentageSize * 100;
                var finishEstimate = new Date(this.startTime.valueOf() + durationEstimate);
                textContainer.innerHTML += ". Estimated finish at: " + this.formatTime(finishEstimate) + ".";
            }
            else {
                textContainer.innerHTML =
                    this.alreadyProcessed + "/" + this.maxCount + " individual files and/or file pairs processed " +
                        "(" + Math.round(percentage) + " %)" +
                        "<br>Started at " + this.formatTime(this.startTime);
            }
        };
        AjaxQueue.prototype.removeProgressbarText = function () {
            var progressbarElement = this.ngProgressbar.getDomElement()[0];
            var textContainer = progressbarElement.querySelector(".progress-bar-text");
            if (textContainer) {
                progressbarElement.removeChild(textContainer);
            }
        };
        AjaxQueue.prototype.formatTime = function (time) {
            var hours = time.getHours();
            var hoursString;
            if (hours <= 9) {
                hoursString = "0" + hours;
            }
            else {
                hoursString = hours.toString();
            }
            var minutes = time.getMinutes();
            var minutesString;
            if (minutes <= 9) {
                minutesString = "0" + minutes;
            }
            else {
                minutesString = minutes.toString();
            }
            return hoursString + ":" + minutesString;
        };
        AjaxQueue.prototype.formatSize = function (bytes) {
            if (bytes >= Math.pow(1024, 3)) {
                var gibiBytes = bytes / Math.pow(1024, 3);
                return gibiBytes.toPrecision(4) + " GiB";
            }
            else if (bytes >= Math.pow(1024, 2)) {
                var mebiBytes = bytes / Math.pow(1024, 2);
                return mebiBytes.toPrecision(3) + " MiB";
            }
            else if (bytes >= Math.pow(1024, 1)) {
                var kibiBytes = bytes / 1024;
                return kibiBytes.toPrecision(3) + " KiB";
            }
            else {
                return bytes + " B";
            }
        };
        return AjaxQueue;
    }());
    BASWebServices.AjaxQueue = AjaxQueue;
    ;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=AjaxQueue.js.map